import * as React from 'react';
import Button from '../components/Button';
import Typography from '../components/Typography';
import ProductHeroLayout from './ProductHeroLayout';
import hero from "../../media/cloud2.webp";
import ContactPopup from '../components/Contactpopup';


export default function ProductHero() {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleMailTo = () => {
    window.location.href = 'mailto:solutions@mktech.cloud';
  };
  
  return (
    <ProductHeroLayout
      sxBackground={{
        backgroundImage: `url(${hero})`,
        backgroundColor: '#7fc7d9', // Average color of the background image.
        backgroundPosition: '50% 38%',
      }}
    >
      <Typography color="inherit" align="center" variant="h2" marked="center" sx={{fontSize: {xs: '36px', md: '74px'}, mt: {xs:1}, mb: {xs:1}}}>
        Transforming<br/>Cloud Solutions
      </Typography>
      <Typography
        color="inherit"
        align="center"
        variant="h5"
        sx={{ mb: 4, mt: { xs: 4, sm: 10 } }}
      >
        From state-of-the-art cloud migrations to securing your digital assets, our expertise is your gateway to a future defined by efficiency, security, and scalability.
        As an established small business based in Annapolis, MD, we serve our local community with the same passion and dedication that we bring to our national clients. We understand the unique challenges and opportunities that come with cloud technologies, and we're here to guide you through every step of your digital transformation journey. 
      </Typography>
      <Button
        color="secondary"
        variant="contained"
        size="large"
        onClick={handleMailTo}
        sx={{ minWidth: 200, mt: 10, borderRadius:1 }}
      >
        Contact Us
      </Button>
      <ContactPopup open={open} handleClose={handleClose} />
    </ProductHeroLayout>
  );
}
